import * as layout from '@ocodelib/compose-layout';
import { CodingTabContent } from '../components/CodingTabContent';
import type { IJsBasicLayoutConfig } from '../types';
import { PLUGIN_KIND_CONTENT } from './plugin-keys';

export function buildLayout(
  overrideCallback?: (layoutManager: layout.ComposeLayoutManager) => void,
) {
  // app의 설정
  const layoutConfig: IJsBasicLayoutConfig = {
    contentTabs: {
      initaialTabKey: 'coding',
      tabs: [{ key: 'coding', name: '코딩', component: <CodingTabContent /> }],
    },
    hidden: [],
  };

  const layoutManager = new layout.ComposeLayoutManager();
  function reg(key: string, component: React.ReactElement) {
    return layoutManager.registerPlugin(key, component);
  }

  // 기본 레이아웃 설정

  // Topbar는 외부에서 설정
  // reg(PLUGIN_KEYS.root.topBar, <WorkspaceTopbar backLink="/coding/dashboard" />);

  // 컨텐트탭 레이아웃 빌드
  layoutConfig.contentTabs.tabs.forEach(({ key, component }) => {
    const pluginKey = PLUGIN_KIND_CONTENT + '.' + key; // ex: 'content.coding'
    reg(pluginKey, component);
  });

  function dispose() {
    layoutManager.destroy();
  }

  if (overrideCallback) {
    overrideCallback(layoutManager);
  }

  debugLayoutManager(layoutManager);
  layoutManager.init();

  return {
    dispose,
    result: {
      layoutManager,
      layoutConfig,
    },
  };
}

function debugLayoutManager(layoutManager: layout.ComposeLayoutManager) {
  // 디버그
  for (const kind of layoutManager.pluginKinds) {
    const registry = layoutManager.getPluginRegistry(kind);
    console.log(`buildLayout(): plugin(kind=${kind})`, registry?.plugins());
  }
}
